import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const AdminRoute = ({ children }) => {
    const token = localStorage.getItem('adminToken');
    const location = useLocation();

    if (!token) {
        // Redirect to login, preserving the intended destination.
        return <Navigate to="/admin" state={{ from: location }} replace />;
    }

    return children;
};

export default AdminRoute;
